import React from 'react';
import { Lock, Eye, FileDigit, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Privacy = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-obsidian text-cream-100 p-6 pt-20">
            <div className="max-w-3xl mx-auto space-y-8">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-cream-200/60 hover:text-cream-50 transition-colors"
                >
                    <ArrowLeft size={20} />
                    Back to Home
                </button>

                <header className="space-y-4">
                    <div className="w-12 h-12 rounded-xl bg-sage-500/20 flex items-center justify-center">
                        <Lock className="w-6 h-6 text-sage-400" />
                    </div>
                    <h1 className="text-4xl font-display font-bold text-cream-50">Privacy Policy</h1>
                    <p className="text-cream-200/60 text-lg">Last updated: February 16, 2026</p>
                </header>

                <div className="space-y-8 text-cream-200/80 leading-relaxed">
                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">1. Data Collection</h2>
                        <p>
                            We collect information you provide directly to us, including:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Account information (email, username).</li>
                            <li>Transaction data (shipping addresses, purchase history).</li>
                            <li>Card collection data (images, grades, values).</li>
                        </ul>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">2. Third-Party Services</h2>
                        <p>
                            We use trusted third-party services to operate our platform:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li><strong>Supabase</strong>: For authentication and database hosting.</li>
                            <li><strong>Stripe</strong>: For secure payment processing. We do not store your credit card information.</li>
                            <li><strong>Ximilar</strong>: For AI card identification and grading. Images you scan are processed by Ximilar.</li>
                        </ul>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">3. Data Usage</h2>
                        <p>
                            We use your data to:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Facilitate marketplace transactions and shipping.</li>
                            <li>Improve our AI card recognition models.</li>
                            <li>Send transaction notifications and updates.</li>
                        </ul>
                    </section>

                    <section className="space-y-4">
                        <h2 className="text-2xl font-display font-semibold text-cream-50">4. Your Rights</h2>
                        <p>
                            You have the right to request a copy of your data or request deletion of your account at any time by contacting support.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};
